import React, { useEffect } from 'react'
import QRCode from 'qrcode.react'
import { useSelector } from 'react-redux'
import { analytics } from 'firebase'

import Status from '../../../Status/Status'
import classes from './Order.module.css'
import Icon from '../../../elements/Icon'
import Arrow from '../../../../images/icon/arrow.svg'
import Loader from '../../../../images/icon/loader.svg'
import StatusCode from '../../../elements/statusCode'
import Done from '../../../../images/icon/done.svg'
import Cancel from '../../../../images/icon/cancel.svg'

import generatorQR from '../../../elements/QRValue'
import PlayMarket from '../../../../images/icon/playMarket.svg'
import AppStore from '../../../../images/icon/appStore.svg'

import orderScreen from '../../../../redux/stores/OrderScreen/orderScreenAction'

import { strings } from '../../../../i18n'
import CheckData from '../../../MobileExchenger/elements/CheckData/CheckData'


const OrderStatus = () => {
    const state = useSelector(state => state.orderScreen)

    useEffect(() => {
        orderScreen()

        window.scroll(0, 0)
    }, [])


    if (!state.orderInfo) {
        return null
    }


    analytics().logEvent('open_OrderScreen')
    analytics().setCurrentScreen('OrderScreen')

    return (
        <>
            {!state.orderInfo.externalId && <Status screen={3} />}
            <div className={classes.third__screen}>
                <div className={classes.finish}>
                    <h3>{strings('thirdScreen.tracking')}</h3>
                    <div className={classes.orderID}>
                        Order ID {state.orderInfo.orderHash}
                    </div>
                    <div className={classes.main__wrapper}>
                        <CheckData data={true} name={strings('firstScreen.youGive') + ':'} value={state.orderInfo.inAmount + ' ' + (state.orderInfo.inCurrencyCode.length > 5 ? state.orderInfo.inCurrencyCode.slice(4, state.orderInfo.inCurrencyCode.length) : state.orderInfo.inCurrencyCode)} />
                        <div style={{ height: 10 }} ></div>
                        <CheckData data={true} name={strings('firstScreen.youGet') + ':'} value={'~ ' + (state.orderInfo.withdrawnAmount ? state.orderInfo.withdrawnAmount : state.orderInfo.expectedAmount) + ' ' + (state.orderInfo.outCurrencyCode.length > 5 ? state.orderInfo.outCurrencyCode.slice(4, state.orderInfo.outCurrencyCode.length) : state.orderInfo.outCurrencyCode)} />
                    </div>
                    <div className={classes.currency}>
                        <div className={classes.currency__value__in}>
                            {state.orderInfo.inAmount} {state.orderInfo.inCurrencyCode.length > 5 ? state.orderInfo.inCurrencyCode.slice(4, state.orderInfo.inCurrencyCode.length) : state.orderInfo.inCurrencyCode}
                        </div>
                        <div className={classes.currency__wrapper}>
                            <Icon currencyCode={state.orderInfo.inCurrencyCode} name={false} />
                            <div className={classes.line}>
                                <div className={classes.circle__arrow}>
                                    <img src={Arrow} alt={'arrow'} />
                                </div>
                            </div>
                            <Icon currencyCode={state.orderInfo.outCurrencyCode} name={false} />
                        </div>
                        <div className={classes.currency__value__out}>
                            ~ {state.orderInfo.withdrawnAmount ? state.orderInfo.withdrawnAmount : state.orderInfo.expectedAmount} {state.orderInfo.outCurrencyCode.length > 5 ? state.orderInfo.outCurrencyCode.slice(4, state.orderInfo.outCurrencyCode.length) : state.orderInfo.outCurrencyCode}
                        </div>
                    </div>
                    <div className={classes.status__description}>
                        {state.orderInfo.orderStatus === 'DONE_PAYOUT' ?
                            <>
                                <p>
                                    {strings('thirdScreen.donePayout')}
                                </p>
                            </>
                            : state.orderInfo.orderStatus === 'CANCELED_PAYOUT' ?
                                <>
                                    <p>
                                        {strings('thirdScreen.canceledPayout')}
                                    </p>
                                </>
                                :
                                <>
                                    <p>
                                        {strings('thirdScreen.anotherStatusHead')}
                                    </p>
                                    <p>
                                        {strings('thirdScreen.anotherStatusMain')}
                                    </p>
                                </>}
                    </div>
                    {state.orderInfo.depositAddress && state.orderInfo.exchangeWayType !== 'BUY' ?
                        <div className={classes.address}>
                            <div className={classes.address__name}>
                                {strings('thirdScreen.depositAddress')}
                            </div>
                            <textarea className={classes.address__value} readOnly={true}>
                                {state.orderInfo.depositAddress}
                            </textarea>
                        </div>
                        : null}
                    {
                        state.orderInfo.depositDestinationTag ?
                            <div className={classes.address}>
                                <div className={classes.address__name}>{strings('firstScreen.outDestinationTag')}</div>
                                <textarea className={classes.address__value} readOnly={true}
                                    style={state.orderInfo.outDestination.length < 25 ? { height: 22 } : null}>
                                    {state.orderInfo.depositDestinationTag}
                                </textarea>
                            </div>
                            : null
                    }
                    <div className={classes.main__wrapper}>
                        <CheckData data={true} name={state.orderInfo.outPaywayCode === 'QIWI' || state.orderInfo.outPaywayCode === 'MOBILE_PHONE' ?
                            strings('thirdScreen.phone') :
                            state.orderInfo.outPaywayCode === 'VISA_MC_P2P' ?
                                strings('firstScreen.card') : strings('firstScreen.outDestination')} value={state.orderInfo.outDestination} />
                    </div>
                    <div className={classes.address}>
                        <div className={classes.address__name}>
                            {state.orderInfo.outPaywayCode === 'QIWI' || state.orderInfo.outPaywayCode === 'MOBILE_PHONE' ?
                                strings('thirdScreen.phone') :
                                state.orderInfo.outPaywayCode === 'VISA_MC_P2P' ?
                                    strings('firstScreen.card') : strings('firstScreen.outDestination')}
                        </div>
                        <textarea className={classes.address__value} readOnly={true}
                            style={state.orderInfo.outDestination.length < 25 ? { height: 22 } : null}
                            value={state.orderInfo.outDestination} />
                    </div>
                    {
                        state.orderInfo.outDestinationTag ?
                            <>
                                <div className={classes.main__wrapper}>
                                    <CheckData data={true} name={strings('firstScreen.outDestinationTag')} value={state.orderInfo.outDestinationTag} />
                                </div>
                                <div className={classes.address}>
                                    <div className={classes.address__name}>{strings('firstScreen.outDestinationTag')}</div>
                                    <textarea className={classes.address__value} readOnly={true}
                                        style={state.orderInfo.outDestination.length < 25 ? { height: 22 } : null}>
                                        {state.orderInfo.outDestinationTag}
                                    </textarea>
                                </div>
                            </>
                            : null
                    }
                    <div className={classes.status__wrapper}
                        style={!generatorQR(state.orderInfo.inPaywayCode, state.orderInfo.depositAddress, state.orderInfo.inAmount) ? { paddingBottom: 60 } : null}>
                        <div className={classes.status}>
                            {strings('thirdScreen.status.status')}
                        </div>
                        <div className={classes.status__value}>
                            <div className={classes.status__value__name}>
                                <StatusCode code={state.orderInfo.orderStatus} />
                            </div>
                            <img
                                src={state.orderInfo.orderStatus.indexOf('CANCELED_') === 0 || state.orderInfo.orderStatus.indexOf('ERROR_') === 0 ? Cancel : state.orderInfo.orderStatus === 'DONE_PAYOUT' ? Done : Loader}
                                alt={'status'} />
                        </div>
                    </div>
                    {state.orderInfo.orderStatus === 'PENDING_PAYIN' && state.orderInfo.exchangeWayType === 'BUY' ?
                        <div className={classes.payin__button}>
                            <a href={state.orderInfo.payinUrl} className={classes.link}
                                target="_blank" rel={'noopener noreferrer'}>
                                <button className={classes.link__button}>
                                    {strings('thirdScreen.pay')}
                                </button>
                            </a>
                        </div> : null}
                    {state.orderInfo.depositAddress && generatorQR(state.orderInfo.inPaywayCode, state.orderInfo.depositAddress, state.orderInfo.inAmount) ?
                        <div className={classes.qr__wrapper}>
                            <div className={classes.message__only__sell}>
                                {strings('thirdScreen.payQR')}
                            </div>
                            <div className={classes.qrcode}>
                                <QRCode
                                    value={generatorQR(state.orderInfo.inPaywayCode, state.orderInfo.depositAddress, state.orderInfo.inAmount)}
                                    size={164} level={'Q'} />
                            </div>
                            <div className={classes.download__text}>
                                {strings('secondScreen.downloadText')}
                            </div>
                            <div className={classes.button__app}>
                                <a href={'https://play.google.com/store/apps/details?id=com.trusteewallet'}
                                    target="_blank" rel={'noopener noreferrer'} onClick={() => {
                                        analytics().logEvent('click_play_market')
                                    }}>
                                    <button>
                                        <img src={PlayMarket} alt={'PlayMarket'} />
                                    </button>
                                </a>
                                <a href={'https://apps.apple.com/ua/app/trustee-wallet/id1462924276'}
                                    target="_blank" rel={'noopener noreferrer'} onClick={() => {
                                        analytics().logEvent('click_app_store')
                                    }}>
                                    <button>
                                        <img src={AppStore} alt={'AppStore'} />
                                    </button>
                                </a>
                            </div>
                        </div>
                        : null}
                </div>
            </div>
        </>
    )
}

export default OrderStatus